import type {Action, ActionReturn} from 'svelte/action';
import {exists, isFunction} from 'shared/utils/custom-utils';
import {isObject} from 'shared/utils/types-utils';

export type ActionEntry<
    Element = HTMLElement,
    Parameter = any,
    Attributes extends Record<string, any> = Record<never, any>
> =
    | Action<Element, Parameter, Attributes>
    | [Action<Element, Parameter, Attributes>, Parameter];

export type ActionArray = ActionEntry[];

// stolen from headless-ui (@rgossiaux/svelte-headlessui)
export function useActions(
    node: HTMLElement,
    actions: ActionArray
) {
    const actionReturns: (ActionReturn | void)[] = [];

    if (exists(actions)) {
        actions.forEach((actionEntry) => {
            const action = Array.isArray(actionEntry) ? actionEntry[0] : actionEntry;
            if (Array.isArray(actionEntry) && actionEntry.length > 1) {
                actionReturns.push(action(node, actionEntry[1]));
            } else {
                actionReturns.push(action(node));
            }
        });
    }

    return {
        update(updatedActions: ActionArray) {
            if (((updatedActions && updatedActions.length) || 0) !== actionReturns.length) {
                throw new Error('You must not change the length of an actions array.');
            }

            if (exists(updatedActions)) {
                for (let i = 0; i < updatedActions.length; i++) {
                    const returnEntry = actionReturns[i];
                    if (isObject(returnEntry) && isFunction(returnEntry.update)) {
                        const actionEntry = updatedActions[i];
                        if (Array.isArray(actionEntry) && actionEntry.length > 1) {
                            returnEntry.update(actionEntry[1]);
                        } else {
                            returnEntry.update(undefined);
                        }
                    }
                }
            }
        },

        destroy() {
            actionReturns.forEach((returnEntry) => {
                if (isObject(returnEntry) && isFunction(returnEntry.destroy)) {
                    returnEntry.destroy();
                }
            });
        },
    };
}